export default (rule, value, callback) => {
  try {
    document.querySelector(value);
    callback();
  } catch {
    callback(new Error('Invalid CSS Selector'));
  }
};
